<script setup>
const media = [
  {
    id: "photo",
    icon: "📷",
    label: "Sesja zdjęciowa Twojej firmy",
    price: 1000,
    desc:
      "Pokaż zespół, przestrzeń, atmosferę. Autentyczne zdjęcia budują wiarygodność i wyróżniają stronę. Realizacja we Wrocławiu.",
  },
  {
    id: "video",
    icon: "🎬",
    label: "Nagranie materiałów wideo na stronę",
    price: 1500,
    desc:
      "Kilka ujęć z życia firmy, wypowiedzi, prezentacja oferty. Krótkie filmy zwiększają zaangażowanie. Realizacja we Wrocławiu.",
  },
];

const selected = ref([]);

const picked = computed(() => media.filter((m) => selected.value.includes(m.id)));
const price = computed(() => picked.value.reduce((s, m) => s + m.price, 0));

defineExpose({
  picked,
  price,
});
</script>

<template>
  <article>
    <header class="mb-3">
      <h2 class="text-xl font-semibold tracking-tight text-slate-900">
        📸 Chcesz pokazać swoją firmę w najlepszym świetle?
      </h2>
      <p class="mt-1.5 text-sm text-slate-600">
        Zdjęcia i wideo na stronie to nie tylko ozdoba — to pierwszy kontakt klienta z
        Twoim światem. Profesjonalna oprawa wizualna zwiększa zaufanie i przekonuje, że
        warto wybrać właśnie Ciebie.
      </p>
    </header>

    <!-- Lista kompaktowa -->
    <div role="group" aria-label="Wybór usług foto/wideo" class="grid grid-cols-1 gap-3">
      <label
        v-for="m in media"
        :key="m.id"
        class="group relative flex items-start gap-3 rounded-xl border border-slate-200 bg-white p-3 shadow-sm transition hover:shadow-md"
        :class="selected.includes(m.id) ? 'ring-2 ring-slate-900 bg-slate-50' : ''"
        @click="
          selected.includes(m.id)
            ? (selected = selected.filter((id) => id !== m.id))
            : selected.push(m.id)
        "
      >
        <!-- Ikona -->
        <div
          class="grid w-9 shrink-0 aspect-square place-items-center rounded-lg bg-gradient-to-br from-slate-900 to-slate-700 text-white shadow"
        >
          {{ m.icon }}
        </div>

        <!-- Tytuł + cena + opis -->
        <div class="min-w-0 flex-1">
          <div class="flex items-baseline justify-between gap-2">
            <h3 class="truncate text-lg font-semibold text-slate-900">
              {{ m.label }}
            </h3>
            <div class="ml-2 flex shrink-0 items-baseline gap-1">
              <span class="text-xl font-semibold text-slate-900">{{ m.price }}</span>
              <span class="text-xs text-slate-500">zł</span>
            </div>
          </div>
          <p :id="`${m.id}-desc`" class="mt-0.5 text-slate-600">
            {{ m.desc }}
          </p>
        </div>
      </label>
    </div>
  </article>
</template>
